import {useDispatch} from "react-redux";
import {useCallback} from "react";
import ScriptNode from "./ScriptNode";
import styles from "./index.module.scss";
import node_styles from "./ScriptNode/index.module.scss";

export default function ScriptsContent({scriptedObjects, selectedKeys, selectObject, onClickScriptItem, addUserScript, removeUserScript}) {
  const dispatch = useDispatch();

  const selectNodeObject = useCallback((uuid, type) => {
    const target = type === "Sprite" ? "2D" : "3D";
    dispatch(selectObject(uuid.substring(0, 3), uuid, target));
  }, []);

  return (
    <div className={styles.container}>
      {scriptedObjects.map(object => {
        return (
          <ScriptNode
            key={object.uuid}
            nodeObject={object}
            depth={0}
            selectedKeys={selectedKeys}
            onClickScriptItem={onClickScriptItem}
            addUserScript={addUserScript}
            removeUserScript={removeUserScript}
            selectNodeObject={selectNodeObject}
          />
        );
      })}
    </div>
  );
}

function addHighlight(element) {
  const location = element.getAttribute("location");
  switch (location) {
    case "node":
      element.classList.add(node_styles.highlighted_node);
      break;
    case "siblingGap":
      element.classList.add(node_styles.highlighted_gap);
      element.parentElement.parentElement.parentElement.previousElementSibling.previousElementSibling.classList.add(
        node_styles.highlighted_node,
      );
      break;
    case "childrenGap":
      element.classList.add(node_styles.highlighted_gap);
      element.parentElement.previousElementSibling.classList.add(node_styles.highlighted_node);
      break;
    default:
      break;
  }
}

function removeHighlight(element) {
  const location = element.getAttribute("location");
  switch (location) {
    case "node":
      element.classList.remove(node_styles.highlighted_node);
      break;
    case "siblingGap":
      element.classList.remove(node_styles.highlighted_gap);
      element.parentElement.parentElement.parentElement.previousElementSibling.previousElementSibling.classList.remove(
        node_styles.highlighted_node,
      );
      break;
    case "childrenGap":
      element.classList.remove(node_styles.highlighted_gap);
      element.parentElement.previousElementSibling.classList.remove(node_styles.highlighted_node);
      break;
    default:
      break;
  }
}

function checkValidation(targetElement, draggedNodeUuid, rootNodeUuid) {
  const uuid = targetElement.getAttribute("uuid");
  if (uuid === draggedNodeUuid) return false;
  else if (uuid === rootNodeUuid) return true;
  return checkValidation(targetElement.parentElement, draggedNodeUuid, rootNodeUuid);
}
